export default __webpack_public_path__ + "static/media/globe.23ee4a39.png";